
const getImageUrlFromBanner = (root) =>
	root.image ? root.image.childImageSharp.fluid.src : null;

export {
	getImageUrlFromBanner,
};
